const DEFAULT_EFFECTUATION_ERROR_MESSAGE =
  "Não foi possível efetivar a proposta. Tente novamente.";

type ProposalEffectuationErrorData = {
  message?: string;
  strMensagem?: string;
};

const htmlEntityMap: Record<string, string> = {
  amp: "&",
  apos: "'",
  aacute: "á",
  acirc: "â",
  agrave: "à",
  atilde: "ã",
  ccedil: "ç",
  eacute: "é",
  ecirc: "ê",
  iacute: "í",
  nbsp: " ",
  oacute: "ó",
  ocirc: "ô",
  otilde: "õ",
  quot: '"',
  uacute: "ú"
};

const decodeHtmlEntities = (message: string): string =>
  message.replace(/&(#\d+|#x[\da-f]+|[a-z]+);/gi, (entity, code) => {
    const normalizedCode = String(code).toLowerCase();

    if (normalizedCode.startsWith("#x")) {
      return String.fromCodePoint(parseInt(normalizedCode.slice(2), 16));
    }

    if (normalizedCode.startsWith("#")) {
      return String.fromCodePoint(parseInt(normalizedCode.slice(1), 10));
    }

    return htmlEntityMap[normalizedCode] || entity;
  });

const getErrorData = (error: unknown): ProposalEffectuationErrorData => {
  const errorObj = error as {
    data?: ProposalEffectuationErrorData;
    response?: { data?: ProposalEffectuationErrorData };
  };

  return errorObj.response?.data || errorObj.data || {};
};

export const getProposalEffectuationErrorMessage = (error: unknown): string => {
  const data = getErrorData(error);
  const message =
    data.strMensagem || data.message || DEFAULT_EFFECTUATION_ERROR_MESSAGE;

  return decodeHtmlEntities(message);
};
